module.exports = function() {
  return new Worker(__webpack_public_path__ + "1e5af79e1db4d9ac8caa.worker.js");
};